import { render, staticRenderFns } from "./WinnersSummaryPlayer.vue?vue&type=template&id=e36d3f6c&scoped=true&"
import script from "./WinnersSummaryPlayer.vue?vue&type=script&lang=js&"
export * from "./WinnersSummaryPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36d3f6c",
  null
  
)

export default component.exports